import { z } from "zod";
const DeliveryLocationSelectorDataSchema = z.object({
  /** Default Location Value */
  defaultLocation: z.string().optional(),
  /** Default State/Province Value */
  defaultState: z.string().optional(),
  /** Reloads the page when automatic process changes their location */
  reloadPageOnAutomaticLocationUpdate: z.boolean().optional(),
  /** Reloads the page when user actively changes their location */
  reloadPageOnManualLocationUpdate: z.boolean().optional(),
  /** Name of the Icon to render */
  iconName: z.string().optional(),
  /** locale */
  locale: z.enum(["en-us", "en-ca", "fr-ca"]),
  /** Portion of the aria-label to display when a value has been set */
  locationAriaLabelPrefix: z.string().optional(),
  /** title of the aria-label to display when a value has been set */
  locationAriaLabelSuffix: z.string().optional(),
  /** Default value of the selector */
  locationSelectorDefault: z.string(),
  /** Label of the selector */
  locationSelectorLabel: z.string(),
  /** Akamai Tooltip Message */
  akamaiSnifferTooltip: z.object({
    delimiter: z.string(),
    message: z.string(),
    buttonAriaLabel: z.string()
  }).optional()
});
export {
  DeliveryLocationSelectorDataSchema
};
